import { render, staticRenderFns } from "./IframeCmp.vue?vue&type=template&id=ffaa0896&scoped=true"
import script from "./IframeCmp.vue?vue&type=script&lang=js"
export * from "./IframeCmp.vue?vue&type=script&lang=js"
import style0 from "./IframeCmp.vue?vue&type=style&index=0&id=ffaa0896&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaa0896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffaa0896')) {
      api.createRecord('ffaa0896', component.options)
    } else {
      api.reload('ffaa0896', component.options)
    }
    module.hot.accept("./IframeCmp.vue?vue&type=template&id=ffaa0896&scoped=true", function () {
      api.rerender('ffaa0896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/bulletinBoard/receivablesStatistics/cmp/IframeCmp.vue"
export default component.exports